module.exports = __webpack_public_path__ + "img/mobile-more.88cfdbcb.svg";